<template>
    <div class="zs-dock-row">
        <i class="fa-regular fa-phone-volume zs-dock-row__lead" />
        <div class="zs-dock-row__main">
            <div class="zs-dock-row__lbl">{{ extensionLabel }}</div>
            <div class="zs-dock-row__sub">{{ describeExtensionLiveCallState(call.state) }} · {{ remoteLabel }}</div>
        </div>
        <button
            v-if="canTransferDeskCall(call)"
            type="button"
            class="zs-btn zs-btn--icon zs-btn--sm"
            v-tooltip="'Transfer desk call'"
            :aria-label="`Transfer desk call with ${remoteLabel} on ${extensionLabel}`"
            data-test="desk-call-transfer"
            @click.stop="openTransfer"
        >
            <i class="fa-solid fa-arrow-right-arrow-left" />
        </button>
    </div>
</template>

<script lang="ts" setup>
import { presentOverlay } from '@zyno-io/vue-foundation';

import type { IExtensionLiveCallResponse } from '@/openapi-clients-generated/talk';

import { describeExtensionLiveCallState, canTransferDeskCall } from '@/modules/talk/helpers/extension-live-calls';

import MDeskCallTransfer from './m-desk-call-transfer.vue';

const props = defineProps<{ call: IExtensionLiveCallResponse; extensionLabel: string; remoteLabel: string }>();

async function openTransfer() {
    if (!canTransferDeskCall(props.call)) return;
    await presentOverlay(MDeskCallTransfer, { call: props.call, extensionLabel: props.extensionLabel, remoteLabel: props.remoteLabel });
}
</script>
